export enum InsuranceDetailKeys {
  Identifier = "identifier",
  PatientMrn = "patient_mrn",
  CreatedAt = "created_at",
  Type = "type",
  Insurer = "insurer",
  EffectiveDate = "effective_date",
  TermDate = "term_date",
  Phone = "phone",
  PolicyNumber = "policy_number",
  GroupNumber = "group_number",
  PlanNumber = "plan_number",
  PlanName = "plan_name",
  RetailBenefit = "retail_benefit",
  MailOrderBenefit = "mail_order_benefit",
  Ltc = "ltc",
  Specialty = "specialty",
}
